import { useMyIntl } from "hooks";
import { useRecoilValue } from "recoil";
import { Button } from "@bit-design/react";
import ErrorImgDark from "assets/img/errorBoundary/error-dark.webp";
import ErrorImgLight from "assets/img/errorBoundary/error-light.webp";
import { isDarkThemeSelector } from "store/data/Base";

const FallbackPage = () => {
  const t = useMyIntl();
  const isDarkTheme = useRecoilValue(isDarkThemeSelector);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <img
        src={isDarkTheme ? ErrorImgDark : ErrorImgLight}
        alt="error"
        className="mt-4 w-[120px]"
      />
      <div className="my-5 text-thirdText">
        {t("netstatus.connect_unstable")}
      </div>
      <Button type="chunky" onClick={() => window.location.reload()}>
        {t("strategy_grid_text.refresh")}
      </Button>
    </div>
  );
};

export default FallbackPage;
